import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Zap, Clock } from "lucide-react";

// Reskinned into the ICE_Man "journey" language: Fraunces serif, champagne gold,
// hairline borders, calm dark panel. API + props unchanged (/priority/spots,
// onClickJoin, onDataLoaded).

var GOLD = "#C9A24E";

export default function ScarcityCounter({ onClickJoin, onDataLoaded }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await api.get("/priority/spots");
        if (mounted) {
          setData(res.data);
          onDataLoaded && onDataLoaded(res.data);
        }
      } catch (e) {
        // silent
      }
    };
    load();
    const t = setInterval(load, 20000);
    return () => { mounted = false; clearInterval(t); };
  }, [onDataLoaded]);

  const remaining = data && typeof data.remaining === "number" ? data.remaining : null;
  const total = (data && data.total) || 5000;
  const price = (data && data.price_usd) || 50;
  const soldOut = remaining !== null && remaining <= 0;
  const pct = remaining !== null ? Math.max(0, Math.min(100, (remaining / total) * 100)) : 0;

  return (
    <div
      data-testid="scarcity-counter"
      style={{
        display: "grid",
        gridTemplateColumns: "1.4fr 1fr",
        gap: "48px",
        alignItems: "center",
        border: "1px solid rgba(243,240,233,0.09)",
        borderRadius: "8px",
        padding: "44px",
        background: "var(--ink, #0D0C10)",
      }}
      className="glx-scarcity"
    >
      <div>
        <div
          style={{
            display: "inline-flex", alignItems: "center", gap: "8px",
            border: "1px solid rgba(243,240,233,0.18)", borderRadius: "999px",
            padding: "7px 14px", fontFamily: "'Space Mono',monospace", fontSize: "10px",
            letterSpacing: ".22em", textTransform: "uppercase", color: GOLD, marginBottom: "22px",
          }}
        >
          <Zap style={{ height: "12px", width: "12px" }} /> Priority premium — limited
        </div>

        <h4 style={{ fontFamily: "'Fraunces',Georgia,serif", fontWeight: 400, fontSize: "clamp(30px,4vw,50px)", lineHeight: 1.0, letterSpacing: "-.02em", margin: 0, color: "var(--t1,#F3F0E9)" }}>
          Secure your <em style={{ fontStyle: "italic", color: GOLD }}>lifetime lane.</em>
        </h4>

        <p style={{ color: "var(--t2,#9A968D)", fontSize: "15.5px", lineHeight: 1.6, margin: "18px 0 26px", maxWidth: "46ch" }}>
          Join the priority waitlist and get{" "}
          <b style={{ color: "var(--t1,#F3F0E9)", fontWeight: 500 }}>two months of free Premium bot usage</b>{" "}
          the moment we launch. One-time crypto payment — USDT, BTC, or ETH.
        </p>

        <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
          <button
            onClick={onClickJoin}
            disabled={soldOut}
            data-testid="priority-cta"
            style={{
              fontFamily: "'Space Mono',monospace", fontSize: "12.5px", padding: "15px 26px",
              borderRadius: "2px", cursor: soldOut ? "not-allowed" : "pointer", border: "1px solid " + GOLD,
              background: GOLD, color: "#08070A", opacity: soldOut ? 0.5 : 1,
              display: "inline-flex", alignItems: "center", gap: "9px",
            }}
          >
            {soldOut ? "Sold out" : "Secure spot · $" + Number(price).toFixed(0)}
          </button>
          <span style={{ fontFamily: "'Space Mono',monospace", fontSize: "11px", color: "var(--t3,#5C594F)", display: "inline-flex", alignItems: "center", gap: "7px" }}>
            <Clock style={{ height: "13px", width: "13px" }} /> Live counter · refreshed every 20s
          </span>
        </div>
      </div>

      <div style={{ textAlign: "right" }} className="glx-scarcity-count">
        <div
          data-testid="scarcity-remaining"
          style={{ fontFamily: "'Fraunces',Georgia,serif", fontWeight: 400, fontSize: "clamp(60px,9vw,104px)", lineHeight: 0.9, letterSpacing: "-.03em", color: GOLD }}
        >
          {remaining !== null ? remaining.toLocaleString() : "…"}
        </div>
        <div style={{ fontFamily: "'Space Mono',monospace", fontSize: "11px", letterSpacing: ".16em", textTransform: "uppercase", color: "var(--t3,#5C594F)", marginTop: "6px" }}>
          Only <b style={{ color: GOLD }}>{remaining !== null ? remaining.toLocaleString() : "—"}</b> / {total.toLocaleString()} spots left
        </div>
        <div style={{ marginTop: "18px", height: "2px", background: "rgba(243,240,233,0.09)", borderRadius: "2px", overflow: "hidden" }}>
          <div style={{ height: "100%", width: pct + "%", background: "linear-gradient(90deg,#8F7328," + GOLD + ")" }} />
        </div>
      </div>
    </div>
  );
}
